module.exports = __webpack_public_path__ + "img/q_img04.37570187.jpg";